import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  Label,
} from "recharts";

interface DataPoint {
  name: string;
  value: number;
  color: string;
}

interface GradientLineChartProps {
  data: DataPoint[];
  title: string;
  xAxisTitle?: string;
  yAxisTitle?: string;
}

const GradientLineChart: React.FC<GradientLineChartProps> = ({
  data,
  title,
  xAxisTitle = "X-Axis",
  yAxisTitle = "Y-Axis",
}) => {
  return (
    <div className="size-full bg-[#10151A] ">
      <h2 className="text-white text-lg text-center mb-4">{title}</h2>
      <div className="h-[calc(100%-2rem)]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart
            data={data}
            margin={{ top: 10, right: 30, left: 25, bottom: 40 }}
          >
            <defs>
              <linearGradient id="lineGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#4CAF50" stopOpacity={0.8} />
                <stop offset="100%" stopColor="#4CAF50" stopOpacity={0.3} />
              </linearGradient>
            </defs>

            <CartesianGrid
              // strokeDasharray="3 3"
              horizontal={true} // Disable horizontal grid lines
              vertical={false} // Ensure vertical grid lines appear for all X-axis values
              stroke="#333"
            />
            {/* ✅ X-Axis with Title */}
            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#fff" }}
            >
              <Label
                value={xAxisTitle}
                offset={-15}
                position="insideBottom"
                style={{ fill: "#fff", fontSize: "14px" }}
              />
            </XAxis>

            {/* ✅ Y-Axis with Title */}
            <YAxis axisLine={false} tickLine={false} tick={{ fill: "#fff" }}>
              <Label
                value={yAxisTitle}
                angle={-90}
                position="insideLeft"
                style={{ fill: "#fff", fontSize: "14px" }}
              />
            </YAxis>
            <Tooltip />
            <Line
              type="monotone"
              dataKey="value"
              stroke="url(#lineGradient)" // ✅ Correct gradient reference
              strokeWidth={3}
              dot={{ fill: "#4CAF50" }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default GradientLineChart;
